import { useEffect, useState } from 'react';
import {
  getLocallyFormattedOfferingData,
  isCourseOfferAvailable,
} from '../utility/useCourseDataHelper';
import {
  getCourseDataByCode,
  getUpcomingCourseOfferingsByCourseCode,
} from '../services/courseService';
import useCountdown from './useCountdown';

const useCourseData = (props) => {
  const { courseCode, withCountdown } = props;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [courseData, setCourseData] = useState(null);
  const [courseOfferings, setCourseOfferings] = useState([]);
  const [hasCourseOffers, setHasCourseOffers] = useState(true);

  const { countdown, setEndDate } = useCountdown(null);

  const fetchCourse = async (courseCode) => {
    if (!courseCode) return;
    setLoading(true);
    const { error, data } = await getCourseDataByCode(courseCode);
    setLoading(false);
    if (error) {
      setError(error);
      return;
    }

    setCourseData(data);
  };

  const fetchUpcomingCourseOfferings = async (courseCode) => {
    setLoading(true);
    const courseOfferingsRes = await getUpcomingCourseOfferingsByCourseCode(
      courseCode
    );

    const { error, data } = courseOfferingsRes;
    setLoading(false);

    if (error || !data) {
      setHasCourseOffers(false);
      return;
    }

    const formattedCourseOfferings = data?.length
      ? data.flatMap((courseOffering) =>
          isCourseOfferAvailable(courseOffering)
            ? [getLocallyFormattedOfferingData(courseOffering)]
            : []
        )
      : [];

    if (!formattedCourseOfferings?.[0]) {
      setHasCourseOffers(false);
    }

    setCourseOfferings(formattedCourseOfferings);
  };

  useEffect(() => {
    setCourseData(null);
    fetchCourse(courseCode);
    setCourseOfferings([]);
    fetchUpcomingCourseOfferings(courseCode);
  }, [courseCode]);

  useEffect(() => {
    const nextCourseDate = courseOfferings?.[0]?.localStartDate;
    if (withCountdown && nextCourseDate) {
      setEndDate(nextCourseDate);
    }
  }, [courseOfferings, setEndDate, withCountdown]);

  return {
    loading,
    error,
    courseData,
    courseOfferings,
    retryFetch: () => fetchCourse(courseCode),
    nextCourseDate: courseOfferings?.[0]?.localStartDate,
    countdown,
    hasCourseOffers,
  };
};

export default useCourseData;
